import React, { useState } from 'react';
import { 
  Box, 
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse
} from '@mui/material';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase';
import { useNavigate } from 'react-router-dom';
import LogoutIcon from '@mui/icons-material/Logout';
import HomeIcon from '@mui/icons-material/Home';
import TempleHinduIcon from '@mui/icons-material/TempleHindu';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import PlaceIcon from '@mui/icons-material/Place';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ImageIcon from '@mui/icons-material/Image';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import EventIcon from '@mui/icons-material/Event';
import ApartmentIcon from '@mui/icons-material/Apartment';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import NavigationIcon from '@mui/icons-material/Navigation';
import LandscapeIcon from '@mui/icons-material/Landscape';
import HistoryIcon from '@mui/icons-material/History';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import InfoIcon from '@mui/icons-material/Info';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import BuildIcon from '@mui/icons-material/Build';
import CelebrationIcon from '@mui/icons-material/Celebration';
import AssignmentIcon from '@mui/icons-material/Assignment';
import BookIcon from '@mui/icons-material/Book';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import NotificationsIcon from '@mui/icons-material/Notifications';
import PaymentIcon from '@mui/icons-material/Payment';
import EmailIcon from '@mui/icons-material/Email';

import PushNotificationsManager from '../components/PushNotificationsManager';
import MessagesManager from '../components/MessagesManager';

// Import CMS components
import ImageSliderManager from '../components/ImageSliderManager';
import AboutSectionManager from '../components/AboutSectionManager';
import AnnouncementsManager from '../components/AnnouncementsManager';
import PoojaSectionManager from '../components/PoojaSectionManager';
import NewsSectionManager from '../components/NewsSectionManager';
import DonationSectionManager from '../components/DonationSectionManager';
import GallerySectionManager from '../components/GallerySectionManager';
import ContactSectionManager from '../components/ContactSectionManager';
import ContactOverviewManager from '../components/ContactOverviewManager';
import ContactInfoManager from '../components/ContactInfoManager';
import MapDirectionsManager from '../components/MapDirectionsManager';
import NearbySectionManager from '../components/NearbySectionManager';
import NearbySectionOverviewManager from '../components/NearbySectionOverviewManager';
import OnlineBookingManager from '../components/OnlineBookingManager';
import DailyPoojaManager from '../components/DailyPoojaManager';
import SpecialPoojaManager from '../components/SpecialPoojaManager';
import FestivalPoojaManager from '../components/FestivalPoojaManager';
import NewsArticlesManager from '../components/NewsArticlesManager';
import UpcomingEventsManager from '../components/UpcomingEventsManager';
import PastEventsManager from '../components/PastEventsManager';
import NewsOverviewManager from '../components/NewsOverviewManager';
import DonatePageManager from '../components/DonatePageManager';
import OnlineDonationManager from '../components/OnlineDonationManager';
import AnnadanamManager from '../components/AnnadanamManager';
import RenovationManager from '../components/RenovationManager';
import FestivalSupportManager from '../components/FestivalSupportManager';
import NoticesManager from '../components/NoticesManager';
import HistoryAboutManager from '../components/HistoryAboutManager';
import DeitiesAboutManager from '../components/DeitiesAboutManager';
import FestivalsAboutManager from '../components/FestivalsAboutManager';
import AdministrationAboutManager from '../components/AdministrationAboutManager';
import RulesAboutManager from '../components/RulesAboutManager';
import PhotosGalleryManager from '../components/PhotosGalleryManager';
import VideosGalleryManager from '../components/VideosGalleryManager';
import EventsGalleryManager from '../components/EventsGalleryManager';
import PremisesGalleryManager from '../components/PremisesGalleryManager';
import BeachesNearbyManager from '../components/BeachesNearbyManager';
import TemplesNearbyManager from '../components/TemplesNearbyManager';
import ViewpointsNearbyManager from '../components/ViewpointsNearbyManager';
import HeritageNearbyManager from '../components/HeritageNearbyManager';
import BoatingNearbyManager from '../components/BoatingNearbyManager';
import ActivitiesNearbyManager from '../components/ActivitiesNearbyManager';
import BusinessPromotionsManager from '../components/BusinessPromotionsManager';
import StorefrontIcon from '@mui/icons-material/Storefront';

const drawerWidth = 280;

interface MenuSection {
  id: string;
  label: string;
  icon: React.ReactNode;
  color?: string;
  subItems?: { id: string; label: string; icon?: React.ReactNode; color?: string }[];
}

const menuSections: MenuSection[] = [
  {
    id: 'overview',
    label: 'Dashboard Overview',
    icon: <DashboardIcon />,
    color: '#FF6B6B'
  },
  {
    id: 'push-notifications',
    label: 'Push Notifications',
    icon: <NotificationsIcon />,
    color: '#7B1FA2'
  },
  {
    id: 'messages',
    label: 'Messages & Feedback',
    icon: <EmailIcon />,
    color: '#0097A7'
  },
  {
    id: 'home',
    label: 'Home Section',
    icon: <HomeIcon />,
    color: '#4ECDC4',
    subItems: [
      { id: 'home-slider', label: 'Image Slider', icon: <ImageIcon />, color: '#FF6B9D' },
      { id: 'home-about', label: 'About Section', icon: <InfoIcon />, color: '#C44569' },
      { id: 'home-pooja', label: 'Pooja Section', icon: <TempleHinduIcon />, color: '#F8B500' },
      { id: 'home-news', label: 'News Section', icon: <AnnouncementIcon />, color: '#FF6348' },
      { id: 'home-donation', label: 'Donation Section', icon: <VolunteerActivismIcon />, color: '#FF5E78' },
      { id: 'home-gallery', label: 'Gallery Section', icon: <PhotoLibraryIcon />, color: '#00D2D3' },
      { id: 'home-nearby', label: 'Nearby Section', icon: <PlaceIcon />, color: '#30B0C0' },
      { id: 'home-contact', label: 'Contact Section', icon: <ContactPhoneIcon />, color: '#6C5CE7' }
    ]
  },
  {
    id: 'pooja',
    label: 'Pooja Section',
    icon: <TempleHinduIcon />,
    color: '#F8B500',
    subItems: [
      { id: 'pooja-booking', label: 'Online Booking', icon: <AssignmentIcon />, color: '#FFA502' },
      { id: 'pooja-daily', label: 'Daily Poojas', icon: <EventIcon />, color: '#FF6B6B' },
      { id: 'pooja-special', label: 'Special Poojas', icon: <CelebrationIcon />, color: '#FFD93D' },
      { id: 'pooja-festival', label: 'Festival Poojas', icon: <EventIcon />, color: '#FF8C42' }
    ]
  },
  {
    id: 'news',
    label: 'News Section',
    icon: <AnnouncementIcon />,
    color: '#FF6348',
    subItems: [
      { id: 'news-overview', label: 'Overview Page', icon: <DashboardIcon />, color: '#FF4757' },
      { id: 'news-announcements', label: 'Announcements', icon: <AnnouncementIcon />, color: '#FD5A8B' },
      { id: 'news-news', label: 'News', icon: <NewspaperIcon />, color: '#FF5252' },
      { id: 'news-upcoming', label: 'Upcoming Events', icon: <EventIcon />, color: '#FF6348' },
      { id: 'news-past', label: 'Past Events', icon: <HistoryIcon />, color: '#D32F2F' },
      { id: 'news-notices', label: 'Notices', icon: <NotificationsIcon />, color: '#FF7043' }
    ]
  },
  {
    id: 'donation',
    label: 'Donation Section',
    icon: <VolunteerActivismIcon />,
    color: '#FF5E78',
    subItems: [
      { id: 'donation-donate', label: 'Overview Page', icon: <DashboardIcon />, color: '#E74C3C' },
      { id: 'donation-online', label: 'Online Donation', icon: <PaymentIcon />, color: '#FF6B9D' },
      { id: 'donation-annadanam', label: 'Annadanam', icon: <RestaurantIcon />, color: '#FF8C42' },
      { id: 'donation-renovation', label: 'Renovation', icon: <BuildIcon />, color: '#FF5E78' },
      { id: 'donation-festival', label: 'Festival Support', icon: <CelebrationIcon />, color: '#FF4757' }
    ]
  },
  {
    id: 'gallery',
    label: 'Gallery Section',
    icon: <PhotoLibraryIcon />,
    color: '#00D2D3',
    subItems: [
      { id: 'gallery-photos', label: 'Photos', icon: <ImageIcon />, color: '#1ABC9C' },
      { id: 'gallery-videos', label: 'Videos', icon: <VideoLibraryIcon />, color: '#16A085' },
      { id: 'gallery-events', label: 'Events', icon: <EventIcon />, color: '#00BCD4' },
      { id: 'gallery-premises', label: 'Premises', icon: <ApartmentIcon />, color: '#26C6DA' }
    ]
  },
  {
    id: 'nearby',
    label: 'Nearby Section',
    icon: <PlaceIcon />,
    color: '#30B0C0',
    subItems: [
      { id: 'nearby-overview', label: 'Overview & Settings', icon: <DashboardIcon />, color: '#0097A7' },
      { id: 'nearby-beaches', label: 'Beaches', icon: <BeachAccessIcon />, color: '#00B8D4' },
      { id: 'nearby-temples', label: 'Temples', icon: <TempleHinduIcon />, color: '#F8B500' },
      { id: 'nearby-viewpoints', label: 'Viewpoints', icon: <LandscapeIcon />, color: '#26A69A' },
      { id: 'nearby-heritage', label: 'Heritage', icon: <HistoryIcon />, color: '#7B1FA2' },
      { id: 'nearby-boating', label: 'Boating', icon: <DirectionsBoatIcon />, color: '#0288D1' },
      { id: 'nearby-activities', label: 'Activities', icon: <LocalActivityIcon />, color: '#00ACC1' }
    ]
  },
  {
    id: 'contact',
    label: 'Contact Section',
    icon: <ContactPhoneIcon />,
    color: '#6C5CE7',
    subItems: [
      { id: 'contact-overview', label: 'Contact Overview', icon: <DashboardIcon />, color: '#5E35B1' },
      { id: 'contact-info-details', label: 'Contact Info', icon: <InfoIcon />, color: '#7C4DFF' },
      { id: 'contact-map-directions', label: 'Map/Directions', icon: <NavigationIcon />, color: '#651FFF' }
    ]
  },
  {
    id: 'about',
    label: 'About Section',
    icon: <TempleHinduIcon />,
    color: '#FF9800',
    subItems: [
      { id: 'about-history', label: 'History', icon: <HistoryIcon />, color: '#E65100' },
      { id: 'about-deities', label: 'Deities', icon: <TempleHinduIcon />, color: '#FF9800' },
      { id: 'about-festivals', label: 'Festivals', icon: <CelebrationIcon />, color: '#FB8C00' },
      { id: 'about-administration', label: 'Administration', icon: <ApartmentIcon />, color: '#FF6F00' },
      { id: 'about-rules', label: 'Rules & Guidelines', icon: <BookIcon />, color: '#FFA726' }
    ]
  },
  {
    id: 'business-promotions',
    label: 'Business Promotions',
    icon: <StorefrontIcon />,
    color: '#9C27B0'
  }
];

// function TabPanel(props: TabPanelProps) {
//   const { children, value, index, ...other } = props;
//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`admin-tabpanel-${index}`}
//       aria-labelledby={`admin-tab-${index}`}
//       {...other}
//     >
//       {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
//     </div>
//   );
// }

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [selectedSection, setSelectedSection] = useState('overview');
  const [openSections, setOpenSections] = useState<{ [key: string]: boolean }>({});

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/login');
    } catch (error) {
      console.error('Failed to log out', error);
    }
  };

  const handleSectionClick = (sectionId: string) => {
    if (menuSections.find(s => s.id === sectionId)?.subItems) {
      setOpenSections(prev => ({ ...prev, [sectionId]: !prev[sectionId] }));
    } else {
      setSelectedSection(sectionId);
    }
  };

  const handleSubItemClick = (subItemId: string) => {
    setSelectedSection(subItemId);
  };

  const renderContent = () => {
    switch (selectedSection) {
      case 'overview':
        return (
          <Box sx={{ bgcolor: '#f5f5f5', minHeight: '100vh', py: 4, px: 2 }}>
            {menuSections.map((section) =>
              section.id !== 'overview' ? (
                <Box key={section.id} sx={{ mb: 6 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                    <Box sx={{ width: 5, height: 32, bgcolor: section.color || '#d4af37', borderRadius: 1 }} />
                    <Typography variant="h5" sx={{ fontWeight: 800, color: section.color || '#d4af37', textTransform: 'uppercase', letterSpacing: 1.5 }}>
                      {section.label}
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 2.5 }}>
                    {section.subItems?.map((subItem) => (
                      <Box
                        key={subItem.id}
                        onClick={() => handleSubItemClick(subItem.id)}
                        sx={{
                          aspect: '1',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          borderRadius: 3,
                          cursor: 'pointer',
                          background: `linear-gradient(135deg, ${subItem.color || section.color}22 0%, ${subItem.color || section.color}11 100%)`,
                          border: `2.5px solid ${subItem.color || section.color}`,
                          color: subItem.color || section.color,
                          fontWeight: 700,
                          fontSize: '0.9rem',
                          textAlign: 'center',
                          transition: 'all 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
                          padding: 2,
                          gap: 1,
                          position: 'relative',
                          overflow: 'hidden',
                          '&:before': {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            left: '-100%',
                            width: '100%',
                            height: '100%',
                            bgcolor: `${subItem.color || section.color}`,
                            transition: 'left 0.35s ease',
                            zIndex: -1
                          },
                          '&:hover': {
                            bgcolor: subItem.color || section.color,
                            color: '#fff',
                            boxShadow: `0 12px 32px ${subItem.color || section.color}40`,
                            transform: 'translateY(-6px) scale(1.02)',
                            border: `2.5px solid ${subItem.color || section.color}`,
                            '&:before': {
                              left: 0
                            }
                          }
                        }}
                      >
                        {subItem.icon && (
                          <Box sx={{ 
                            display: 'flex', 
                            fontSize: '2.2rem',
                            color: 'inherit',
                            filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))'
                          }}>
                            {subItem.icon}
                          </Box>
                        )}
                        <span style={{ position: 'relative', zIndex: 2 }}>{subItem.label}</span>
                      </Box>
                    ))}
                  </Box>
                </Box>
              ) : null
            )}
          </Box>
        );
      case 'push-notifications':
        return <PushNotificationsManager />;
      case 'messages':
        return <MessagesManager />;
      case 'home-slider':
      case 'slider':
        return <ImageSliderManager />;
      case 'home-about':
      case 'about':
        return <AboutSectionManager />;
      case 'home-pooja':
      case 'pooja':
        return <PoojaSectionManager />;
      case 'home-news':
      case 'news':
        return <NewsSectionManager />;
      case 'home-donation':
      case 'donation':
        return <DonationSectionManager />;
      case 'home-gallery':
      case 'gallery':
        return <GallerySectionManager />;
      case 'home-nearby':
      case 'nearby':
        return <NearbySectionManager />;
      case 'nearby-overview':
        return <NearbySectionOverviewManager />;
      case 'home-contact':
      case 'contact':
        return <ContactSectionManager />;
      case 'contact-overview':
        return <ContactOverviewManager />;
      case 'contact-info-details':
        return <ContactInfoManager />;
      case 'contact-map-directions':
        return <MapDirectionsManager />;

      case 'about-history':
        return <HistoryAboutManager />;
      case 'about-deities':
        return <DeitiesAboutManager />;
      case 'about-festivals':
        return <FestivalsAboutManager />;
      case 'about-administration':
        return <AdministrationAboutManager />;
      case 'about-rules':
        return <RulesAboutManager />;
      case 'gallery-photos':
        return <PhotosGalleryManager />;
      case 'gallery-videos':
        return <VideosGalleryManager />;
      case 'gallery-events':
        return <EventsGalleryManager />;
      case 'gallery-premises':
        return <PremisesGalleryManager />;
      case 'nearby-beaches':
        return <BeachesNearbyManager />;
      case 'nearby-temples':
        return <TemplesNearbyManager />;
      case 'nearby-viewpoints':
        return <ViewpointsNearbyManager />;
      case 'nearby-heritage':
        return <HeritageNearbyManager />;
      case 'nearby-boating':
        return <BoatingNearbyManager />;
      case 'nearby-activities':
        return <ActivitiesNearbyManager />;
      case 'news-overview':
        return <NewsOverviewManager />;
      case 'news-announcements':
        return <AnnouncementsManager />;
      case 'news-news':
        return <NewsArticlesManager />;
      case 'news-upcoming':
        return <UpcomingEventsManager />;
      case 'news-past':
        return <PastEventsManager />;
      case 'news-notices':
        return <NoticesManager />;
      case 'donation-donate':
        return <DonatePageManager />;
      case 'donation-online':
        return <OnlineDonationManager />;
      case 'donation-annadanam':
        return <AnnadanamManager />;
      case 'donation-renovation':
        return <RenovationManager />;
      case 'donation-festival':
        return <FestivalSupportManager />;
      case 'pooja-booking':
        return <OnlineBookingManager />;
      case 'pooja-daily':
        return <DailyPoojaManager />;
      case 'pooja-special':
        return <SpecialPoojaManager />;
      case 'pooja-festival':
        return <FestivalPoojaManager />;
      case 'business-promotions':
        return <BusinessPromotionsManager />;
      default:
        return (
          <Box>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 700 }}>
              {menuSections.find(s => s.id === selectedSection.split('-')[0])?.label || 'Content Manager'}
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary' }}>
              Content management for this section is coming soon...
            </Typography>
          </Box>
        );
    }
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {/* Top App Bar */}
      <AppBar 
        position="fixed" 
        sx={{ 
          zIndex: (theme) => theme.zIndex.drawer + 1,
          bgcolor: '#d4af37', 
          color: '#000' 
        }}
      >
        <Toolbar>
          <DashboardIcon sx={{ mr: 2 }} />
          <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontWeight: 700 }}>
            Temple CMS Admin Dashboard
          </Typography>
          <IconButton color="inherit" onClick={handleLogout} title="Logout">
            <LogoutIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Left Sidebar Drawer */}
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            bgcolor: '#fafafa',
            borderRight: '2px solid #d4af37'
          },
        }}
      >
        <Toolbar /> {/* Spacer for AppBar */}
        <Box sx={{ overflow: 'auto', pt: 2 }}>
          <List>
            {menuSections.map((section) => (
              <React.Fragment key={section.id}>
                <ListItemButton
                  selected={selectedSection === section.id || selectedSection.startsWith(section.id + '-')}
                  onClick={() => handleSectionClick(section.id)}
                  sx={{
                    mx: 1,
                    mb: 0.5,
                    borderRadius: 2,
                    '&.Mui-selected': {
                      bgcolor: '#d4af37',
                      color: '#000',
                      fontWeight: 700,
                      '&:hover': {
                        bgcolor: '#e5c158',
                      },
                      '& .MuiListItemIcon-root': {
                        color: '#000',
                      }
                    },
                    '&:hover': {
                      bgcolor: 'rgba(212, 175, 55, 0.1)',
                    }
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 40 }}>
                    {section.icon}
                  </ListItemIcon>
                  <ListItemText 
                    primary={section.label} 
                    primaryTypographyProps={{ 
                      fontSize: '0.9rem',
                      fontWeight: selectedSection === section.id || selectedSection.startsWith(section.id + '-') ? 700 : 500
                    }}
                  />
                  {section.subItems && (
                    openSections[section.id] ? <ExpandLess /> : <ExpandMore />
                  )}
                </ListItemButton>

                {section.subItems && (
                  <Collapse in={openSections[section.id]} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {section.subItems.map((subItem) => (
                        <ListItemButton
                          key={subItem.id}
                          selected={selectedSection === subItem.id}
                          onClick={() => handleSubItemClick(subItem.id)}
                          sx={{
                            pl: 6,
                            mx: 1,
                            mb: 0.5,
                            borderRadius: 2,
                            '&.Mui-selected': {
                              bgcolor: 'rgba(212, 175, 55, 0.3)',
                              fontWeight: 600,
                              '&:hover': {
                                bgcolor: 'rgba(212, 175, 55, 0.4)',
                              }
                            },
                            '&:hover': {
                              bgcolor: 'rgba(212, 175, 55, 0.05)',
                            }
                          }}
                        >
                          <ListItemText 
                            primary={subItem.label}
                            primaryTypographyProps={{ 
                              fontSize: '0.85rem',
                              fontWeight: selectedSection === subItem.id ? 600 : 400
                            }}
                          />
                        </ListItemButton>
                      ))}
                    </List>
                  </Collapse>
                )}
              </React.Fragment>
            ))}
          </List>
        </Box>
      </Drawer>

      {/* Main Content Area */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: '#f5f5f5',
          p: 3,
          minHeight: '100vh'
        }}
      >
        <Toolbar /> {/* Spacer for AppBar */}
        <Box sx={{ maxWidth: 1400, mx: 'auto' }}>
          {renderContent()}
        </Box>
      </Box>
    </Box>
  );
};

export default AdminDashboard;
